module.exports = "<div class=\"_avatar\" v-bind:class=\"[size]\">\n\n <div class=\"inner-avatar\" v-bind:style=\"style\"></div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/plain/avatar/avatar.vue
// module id = 418
// module chunks = 0